import React from 'react';
import { useTranslation } from 'react-i18next';
import { SlideCaptcha as SlideCaptchaUI } from '@jagad/ui';
import type { SlideCaptchaProps as SlideCaptchaUIProps, CaptchaData } from '@jagad/ui';

export type { CaptchaData };
export type SlideCaptchaProps = Omit<
  SlideCaptchaUIProps,
  | 'titleText'
  | 'retryText'
  | 'noDataAvailableText'
  | 'backgroundAltText'
  | 'pieceAltText'
  | 'validatingText'
  | 'sliderHandleText'
  | 'instructionText'
>;

const SlideCaptcha: React.FC<SlideCaptchaProps> = (props) => {
  const { t } = useTranslation();

  return (
    <SlideCaptchaUI
      {...props}
      titleText={t('captcha.title')}
      retryText={t('captcha.retry')}
      noDataAvailableText={t('captcha.noDataAvailable')}
      backgroundAltText={t('captcha.altText.background')}
      pieceAltText={t('captcha.altText.piece')}
      validatingText={t('captcha.validating')}
      sliderHandleText={t('captcha.sliderHandle')}
      instructionText={t('captcha.instruction')}
    />
  );
};

export { SlideCaptcha as default };
